
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13.5","cy":"13.5","r":"13.5","fill":"#E8F8F8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.687 13.742a2.053 2.053 0 00-2.053 2.053v2.737a.684.684 0 11-1.369 0V15.77a2.413 2.413 0 01-.565.014.684.684 0 01-.12.01h-.292c-.594 0-1.076.482-1.076 1.076v.978a.684.684 0 01-1.368 0v-.978c0-.87.454-1.633 1.138-2.067a2.395 2.395 0 012.977-3.563 2.737 2.737 0 115.454 0 2.395 2.395 0 012.977 3.563 2.442 2.442 0 011.14 2.067v.978a.684.684 0 11-1.37 0v-.978c0-.594-.48-1.075-1.075-1.075h-.293a.684.684 0 01-.119-.01 2.427 2.427 0 01-.565-.015v2.762a.684.684 0 11-1.369 0v-2.737a2.053 2.053 0 00-2.052-2.053zm0-1.369a1.369 1.369 0 110-2.737 1.369 1.369 0 010 2.737zm-3.764 0a1.026 1.026 0 100 2.053 1.026 1.026 0 000-2.053zm7.527 0a1.026 1.026 0 100 2.053 1.026 1.026 0 000-2.053z","fill":"#71D6D2"}})])
          )
        }
      }
    